<template>
  <div class="dialog-radio">
    <label class="dialog-radio-label">{{ title }}：</label>
    <div class="dialog-radio-options">
      <label
        v-for="option in options"
        :key="option"
        class="dialog-radio-option"
      >
        <input
          v-if="multiple"
          type="checkbox"
          :name="title"
          :value="option"
          :checked="isSelected(option)"
          @change="onCheckboxChange(option)"
        />
        <input
          v-else
          type="radio"
          :name="title"
          :value="option"
          v-model="innerValue"
        />
        <span class="dialog-radio-box"></span>
        <span class="dialog-radio-text">{{ option }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: [String, Array],
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      innerValue: this.value,
      checkboxValue: [],
    };
  },

  created() {
    if (this.multiple) {
      this.checkboxValue = this.parseMultipleValue(this.value);
    }
  },

  watch: {
    value(newVal) {
      if (this.multiple) {
        this.innerValue = newVal;
        this.checkboxValue = this.parseMultipleValue(newVal);
      } else {
        this.innerValue = newVal;
      }
    },
    innerValue(newVal) {
      if (!this.multiple) {
        this.$emit("input", newVal);
      }
    },
  },

  methods: {
    parseMultipleValue(val) {
      if (!val) return [];
      return val
        .split(",")
        .filter(Boolean)
        .map((item) => (item === "粉尘螨" ? "户尘螨" : item));
    },
    isSelected(option) {
      return this.checkboxValue.includes(option);
    },
    onCheckboxChange(option) {
      const index = this.checkboxValue.indexOf(option);
      if (index > -1) {
        this.checkboxValue.splice(index, 1);
      } else {
        this.checkboxValue.push(option);
      }
      this.$emit("input", this.checkboxValue.join(","));
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-radio {
  display: flex;
  align-items: center;

  &-label {
    width: rem(80);
    margin-right: rem(10);
    text-align: right;
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
  }

  &-options {
    display: flex;
    align-items: center;
    gap: rem(20);
  }

  &-option {
    display: flex;
    align-items: center;
    cursor: pointer;

    input[type="checkbox"] {
      display: none;

      &:checked + .dialog-radio-box {
        border-color: #325fac;

        &::after {
          opacity: 1;
        }
      }
    }

    input[type="radio"] {
      display: none;

      &:checked + .dialog-radio-box {
        border-color: #325fac;

        &::after {
          opacity: 1;
        }
      }
    }

    .dialog-radio-box {
      width: rem(16);
      height: rem(16);
      border: 1px solid #d9d9d9;
      border-radius: rem(2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: rem(6);
      position: relative;
      transition: all 0.2s;

      &::after {
        content: "";
        width: rem(10);
        height: rem(10);
        background-color: #325fac;
        border-radius: rem(2);
        opacity: 0;
        transition: opacity 0.2s;
      }
    }

    .dialog-radio-text {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(14);
    }
  }
}
</style>
